export const UserPermission = {
  Editor: 1,
  Viewer: 2,  
  Admin: 3,
} as const;

export type UserPermission = typeof UserPermission[keyof typeof UserPermission];

export const UserPermissionLabels: Record<UserPermission, string> = {
  [UserPermission.Editor]: '編集者',
  [UserPermission.Viewer]: '閲覧のみ',
  [UserPermission.Admin]: '管理者',
};